/* eslint-disable prefer-rest-params,prefer-destructuring*/
const HEX_REG = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
const RGB_REG = /^rgb\((\d+,?\s*){3}\)$/;
const RGBA_REG = /^rgba\((\d+,?\s*){3},\s*[0-9.]+\)$/;

const checkUtils = {};

// 类型校验
function buildTypeChecker(checkUtils) {
  const types = ['Number', 'String', 'Function', 'Undefined', 'Boolean', 'Object', 'Array'];
  types.forEach((type) => {
    // eslint-disable-next-line no-param-reassign
    checkUtils[`is${type}`] = function (value) {
      const typeName = `[object ${type}]`;
      return typeName === Object.prototype.toString.call(value);
    };
  });
}

buildTypeChecker(checkUtils);

// NaN校验
checkUtils.isNaN = Number.isNaN;

// 经纬度校验
checkUtils.isValidLatLng = function () {
  let lat; let lng;

  if (arguments.length === 1) {
    // [lat, lng] 或 {lat, lng} 或 TMap.LatLng
    // eslint-disable-next-line prefer-rest-params
    const latLng = arguments[0];
    if (checkUtils.isArray(latLng)) {
      // lat = latLng[0];
      // lng = latLng[1];
      [lat, lng] = latLng;
    } else {
      lat = latLng.lat;
      lng = latLng.lng;
    }
  } else if (arguments.length === 2) {
    // lat, lng
    lat = arguments[0];
    lng = arguments[1];
  } else {
    // 无效参数
    return false;
  }

  if (checkUtils.isNumber(lat) && checkUtils.isNumber(lng)) {
    return Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  }
  return false;
};

/**
 * 检查颜色是否有效
 */
checkUtils.isValidColor = function (color) {
  if (checkUtils.isArray(color)) {
    if (color.length === 3 || color.length === 4) {
      return color.every(c => c >= 0 && c <= 255);
    }
    return false;
  } if (checkUtils.isString(color)) {
    return HEX_REG.test(color) || RGB_REG.test(color) || RGBA_REG.test(color);
  }

  return false;
};

/**
 * 检查offset {x: number, y: number}是否有效
 */
checkUtils.isValidOffset = function (offset) {
  if (checkUtils.isObject(offset)) {
    if (('x' in offset) && ('y' in offset) && checkUtils.isNumber(offset.x) && checkUtils.isNumber(offset.y)) {
      return true;
    }
  }

  return false;
};
checkUtils.isVector3 = function (value) {
  return checkUtils.isArray(value) && value.length === 3 && value.every(v => checkUtils.isNumber(v));
};
export default checkUtils;
